import { render, staticRenderFns } from "./TopFiltersBar.vue?vue&type=template&id=65a1ae70&scoped=true&"
import script from "./TopFiltersBar.vue?vue&type=script&lang=ts&"
export * from "./TopFiltersBar.vue?vue&type=script&lang=ts&"
import style0 from "./TopFiltersBar.vue?vue&type=style&index=0&id=65a1ae70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a1ae70",
  null
  
)

export default component.exports